// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main>div[data-v-7df20f98]{display:flex;align-items:center;justify-content:center;height:100vh}", ""]);
// Exports
module.exports = exports;
